/* Compra do kit: uma chamada cart/add.js com as variantes dos componentes.
   O produto pai não entra no carrinho. Sucesso vai para /cart. */
(function () {
  var root = document.querySelector('[data-tt-kit]');
  if (!root) return;

  var dataEl = document.getElementById('tt-kit-data');
  if (!dataEl) return;

  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var lock = false;
  var buttons = root.querySelectorAll('[data-tt-kit-buy]');
  var errorEl = root.querySelector('[data-tt-kit-error]');
  var sticky = root.querySelector('[data-tt-kit-sticky]');
  var heroBtn = root.querySelector('[data-tt-kit-pos="hero"]');

  function track(name, extra) {
    var payload = {
      kit_id: data.kitId,
      kit_name: data.kitName,
      price: data.price,
      savings: data.savings,
      component_ids: (data.items || []).map(function (item) { return item.id; }),
      component_count: (data.items || []).length
    };
    if (extra) {
      Object.keys(extra).forEach(function (key) { payload[key] = extra[key]; });
    }
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish(name, payload);
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
  }

  function cartAddUrl() {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || data.root || '/';
    if (base.slice(-1) !== '/') base += '/';
    return base + 'cart/add.js';
  }

  function cartPageUrl() {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || data.root || '/';
    if (base.slice(-1) !== '/') base += '/';
    return base + 'cart';
  }

  function instanceId() {
    if (window.crypto && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    return 'kit-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }

  function setBusy(busy) {
    buttons.forEach(function (btn) {
      btn.disabled = busy;
      btn.setAttribute('aria-busy', busy ? 'true' : 'false');
      var label = btn.querySelector('[data-tt-kit-label]');
      if (!label) return;
      if (!btn.dataset.idleLabel) btn.dataset.idleLabel = label.textContent;
      label.textContent = busy ? 'Adicionando o kit…' : btn.dataset.idleLabel;
    });
  }

  function showError(message) {
    if (!errorEl) return;
    errorEl.hidden = false;
    errorEl.textContent = message;
  }

  function buy(position) {
    if (lock) return;
    var items = data.items || [];
    if (!items.length) {
      showError('Este kit ainda não tem os produtos vinculados.');
      track('add_kit_error', { position: position, error: 'sem componentes' });
      return;
    }

    var missing = items.filter(function (item) { return item.available === false; });
    if (missing.length) {
      var names = missing.map(function (item) { return item.title; }).join(', ');
      var msg = 'Não foi possível montar o kit. Sem estoque: ' + names + '.';
      showError(msg);
      track('add_kit_error', { position: position, error: msg });
      return;
    }

    lock = true;
    setBusy(true);
    if (errorEl) errorEl.hidden = true;
    track('click_buy_kit', { position: position });

    var instance = instanceId();
    var body = {
      items: items.map(function (item) {
        return {
          id: item.id,
          quantity: 1,
          properties: {
            _kit_name: data.kitName,
            _kit_id: String(data.kitId),
            _kit_url: data.kitUrl || '',
            _kit_instance: instance
          }
        };
      })
    };

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (json) {
          return { ok: res.ok, status: res.status, json: json };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var desc = (result.json && (result.json.description || result.json.message)) || '';
          var msg = desc
            ? 'Não foi possível adicionar o kit. ' + desc
            : 'Não foi possível adicionar o kit. Tente de novo.';
          lock = false;
          setBusy(false);
          showError(msg);
          track('add_kit_error', { position: position, error: desc || ('http ' + result.status) });
          return;
        }
        track('add_kit_success', { position: position, kit_instance: instance });
        window.location.assign(cartPageUrl());
      })
      .catch(function () {
        lock = false;
        setBusy(false);
        var msg = 'Não foi possível adicionar o kit. Verifique a conexão e tente de novo.';
        showError(msg);
        track('add_kit_error', { position: position, error: 'rede' });
      });
  }

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      buy(btn.getAttribute('data-tt-kit-pos') || 'hero');
    });
  });

  root.addEventListener('click', function (event) {
    var link = event.target.closest('[data-tt-kit-component]');
    if (!link) return;
    track('view_kit_component', {
      component_id: link.getAttribute('data-component-id'),
      component_name: link.getAttribute('data-component-name')
    });
  });

  track('view_kit', {});

  if (sticky && heroBtn && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      var visible = entries[0] && entries[0].isIntersecting;
      sticky.classList.toggle('is-on', !visible);
      sticky.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }, { threshold: 0.2 });
    observer.observe(heroBtn);
  }
})();
